/** Une clases y descarta lo falso: `cx(s.base, activo && s.activo, className)`. */
export function cx(...clases: Array<string | false | null | undefined>): string {
  return clases.filter(Boolean).join(" ");
}
